import { ActionTree } from 'vuex'
import { Things } from './types'
import { RootState } from '../types'
import ThingsHelpers from '@/helpers/things/thingsHelpers'

export const actions: ActionTree<Things, RootState> = {
  setThings({ commit }, payload) {
    //commit('cleanThingsState')

    if (payload.length > 0) {
      payload.forEach(thing => {
        const id = ThingsHelpers.getThingId(thing)
        const uriId = thing.id
        const name = thing.info.label
        const type = ThingsHelpers.getThingType(thing)
        //Actualmente el thing "flex" no tiene subtype, al momento se asigna el type como subtype
        const subType = thing.info.subtype ? thing.info.subtype : type
        const domain = ThingsHelpers.getThingDomain(thing)
        const lastReport = thing.metadata.reported_state.hasOwnProperty(
          'location'
        )
          ? thing.metadata.reported_state.location.timestamp
          : ''
        const agents = ThingsHelpers.getThingAgents(thing)
        const serviceName = ThingsHelpers.getThingServiceSolution(thing)
        const serviceStatus = ThingsHelpers.getThingServiceState(thing)
        const created = ThingsHelpers.getThingCreated(thing)
        const serviceList = ThingsHelpers.getThingServiceList(thing)

        let dataThing

        switch (type) {
          case 'vehicle':
            const make = ThingsHelpers.getThingMake(thing)
            const model = ThingsHelpers.getThingModel(thing)
            const year = ThingsHelpers.getThingYear(thing)
            const color = ThingsHelpers.getThingColor(thing)
            const chasisNumber = ThingsHelpers.getThingChasisNumber(thing)
            const engineNumber = ThingsHelpers.getThingEngineNumber(thing)

            dataThing = {
              id,
              uriId,
              name,
              type,
              subType,
              domain,
              lastReport,
              agents,
              make,
              model,
              year,
              color,
              chasisNumber,
              engineNumber,
              serviceName,
              serviceStatus,
              created,
              serviceList
            }
            break
          case 'flex':
            dataThing = {
              id,
              uriId,
              name,
              type,
              subType,
              domain,
              lastReport,
              agents,
              serviceName,
              serviceStatus,
              created,
              serviceList
            }
            break
          default:
            break
        }

        commit('setThings', dataThing)
      })
    }
  },
  setCurrentThing({ commit }, payload) {
    return new Promise<void>((resolve, reject) => {
      commit('setCurrentThing', payload)
      resolve()
      // setTimeout(() => {
      //   commit('someMutation')

      // }, 1000)
    })
  },
  cleanThingsState({ commit }) {
    commit('cleanThingsState')
  },
  setResponseError({ commit }, payload) {
    commit('setResponseError', payload)
  },
  setResponseMessage({ commit }, message) {
    commit('setResponseMessage', message)
  },
  updateThingName({ commit }, payload) {
    commit('updateThingName', payload)
  }
}
